const neirfeno: string = require('../../assets/img/Neirfeno.svg').default
const uod: string = require('../../assets/img/UOD.jpeg')
const ncr: string = require('../../assets/img/NCR.png')

const companyLogos = { neirfeno, uod, ncr }

export default companyLogos
